import { RouteConfig } from 'vue-router'

const forwarderRoutes: Array<RouteConfig> = [
  {
    path: ':role/forwarder_executive',
    name: 'forwarder_executive',
    meta: { inherit: true },
    component: () => import('../SystemExecutive.vue'),
  },
]

export default forwarderRoutes
